// libraries
import React from "react";

// components
import Content from "src/components/EventDetails/Content/Content";

const Details = (props) => {
  const { eventId, timeId } = props.match.params || { eventId: 0, timeId: 0 };

  return <Content eventId={eventId} timeId={timeId} />;
};

export default Details;
